//#region src/api/orpc/payment/extraPackage/confirmErrors.ts
const ConfirmErrorCode = {
	ORDER_NOT_FOUND: "ORDER_NOT_FOUND",
	ORDER_NOT_OWNED: "ORDER_NOT_OWNED",
	NOT_EXTRA_PACKAGE_ORDER: "NOT_EXTRA_PACKAGE_ORDER",
	PROVIDER_ENDPOINT_MISMATCH: "PROVIDER_ENDPOINT_MISMATCH",
	ORDER_NOT_DISPATCHED: "ORDER_NOT_DISPATCHED",
	PROVIDER_QUERY_FAILED: "PROVIDER_QUERY_FAILED",
	INVALID_RECEIPT: "INVALID_RECEIPT",
	RECEIPT_USED_BY_OTHER_ORDER: "RECEIPT_USED_BY_OTHER_ORDER",
	RECEIPT_USER_MISMATCH: "RECEIPT_USER_MISMATCH",
	RECEIPT_PRODUCT_MISMATCH: "RECEIPT_PRODUCT_MISMATCH"
};
const sharedConfirmErrors = {
	[ConfirmErrorCode.ORDER_NOT_FOUND]: {
		status: 404,
		message: "Order not found"
	},
	[ConfirmErrorCode.ORDER_NOT_OWNED]: {
		status: 403,
		message: "Order does not belong to caller"
	},
	[ConfirmErrorCode.NOT_EXTRA_PACKAGE_ORDER]: {
		status: 400,
		message: "Order is not for extra package"
	},
	[ConfirmErrorCode.PROVIDER_ENDPOINT_MISMATCH]: {
		status: 400,
		message: "Order provider does not match this confirm endpoint"
	},
	[ConfirmErrorCode.ORDER_NOT_DISPATCHED]: {
		status: 400,
		message: "Order has not been dispatched yet"
	},
	[ConfirmErrorCode.PROVIDER_QUERY_FAILED]: {
		status: 502,
		message: "Provider query failed; please retry"
	}
};
const iapConfirmErrors = {
	[ConfirmErrorCode.INVALID_RECEIPT]: {
		status: 400,
		message: "Receipt is invalid"
	},
	[ConfirmErrorCode.RECEIPT_USED_BY_OTHER_ORDER]: {
		status: 409,
		message: "Receipt has been used by another order"
	},
	[ConfirmErrorCode.RECEIPT_USER_MISMATCH]: {
		status: 400,
		message: "Receipt user does not match order user"
	},
	[ConfirmErrorCode.RECEIPT_PRODUCT_MISMATCH]: {
		status: 400,
		message: "Receipt productId does not match order SKU"
	}
};
//#endregion
export { ConfirmErrorCode, iapConfirmErrors, sharedConfirmErrors };
